module.exports = __webpack_public_path__ + "static/media/animal.971ab8de.svg";